import "./DecisionEdit.scss";
import {
  Col,
  Row,
  Radio,
  Form
} from "antd";

import { useTranslation } from "react-i18next";
import { SubsectionEdit, ParagraphEdit } from '..'

const DecisionEdit = ({ form, section, component, lang, handleChangeValuesSection, getComponentByType, getTooltipComponent, isKycForm, getDecisionRiskTooltip, showDecisionRiskSelector }) => {
	const { t } = useTranslation('forms')

  return (
    <div className="form-manager-comp-decision-edit">
      <Row>
        <Col span={21}>
          <Form.Item label={t('forms.label.textoDecision')}>
            <ParagraphEdit form={form} section={section} component={component} lang={lang} handleChangeValuesSection={handleChangeValuesSection} />
          </Form.Item>
        </Col>
        <Col span={2} offset={1}>
          <Form.Item label={t('forms.label.decision')}>
            <Radio.Group disabled>
              <Radio className="radio-switch" value={true}>
                {t('forms.options.si')}
              </Radio>
              <Radio className="radio-switch" value={false}>
                {t('forms.options.no')}
              </Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Form.Item label={t('forms.label.elementsYes')}>
          <SubsectionEdit form={form} section={section} component={component} subsection={component.compSi} lang={lang}
                  handleChangeValuesSection={handleChangeValuesSection}
                  getComponentByType={getComponentByType} getTooltipComponent={getTooltipComponent}
                  isKycForm={isKycForm} getDecisionRiskTooltip={getDecisionRiskTooltip}
                  showDecisionRiskSelector={showDecisionRiskSelector} />
        </Form.Item>
      </Row>
      <Row>
        <Form.Item label={t('forms.label.elementsNo')}>
          <SubsectionEdit form={form} section={section} component={component} subsection={component.compNo} lang={lang}
                  handleChangeValuesSection={handleChangeValuesSection}
                  getComponentByType={getComponentByType} getTooltipComponent={getTooltipComponent}
                  isKycForm={isKycForm} getDecisionRiskTooltip={getDecisionRiskTooltip}
                  showDecisionRiskSelector={showDecisionRiskSelector} />
        </Form.Item>
      </Row>

    </div>
  )
}
export default DecisionEdit;
